import { Component, Input, OnInit } from '@angular/core';

import * as moment from 'moment';

@Component({
  selector: 'record-item',
  templateUrl: './record-item.component.html',
  styleUrls: ['./record-item.component.scss'],
})
export class RecordItemComponent implements OnInit {
  @Input() record: any;
  constructor() {}

  ngOnInit() {}

  get date() {
    return this.record.createdAt;
  }

  toggleText() {
    let text = document.getElementById(`${this.record.action}`);
    let btn = document.getElementById(`${this.record._id}`);
    if (text.classList.contains('expanded')) {
      text.classList.remove('expanded');
      btn.textContent = 'Leer más';
    } else {
      text.classList.add('expanded');
      btn.textContent = 'Leer menos';
    }
  }
}
